var Handlebars = require("/home/admin/gitlab_code/assets/enhancer/project-center-assets/node_modules/handlebars/runtime.js");
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    return "	<div>"
    + container.escapeExpression(require("/home/admin/gitlab_code/assets/enhancer/project-center-assets/helpers/i18n.js").call(depth0 != null ? depth0 : (container.nullContext || {}),"home.no.pub",{"name":"i18n","hash":{},"data":data}))
    + "</div>\n";
},"3":function(container,depth0,helpers,partials,data) {
    return "<iframe class=\"delivery-management\"\n	style=\"width: 1024px; border: none; height: calc(100% - 6px); overflow: auto\"\n	src=\""
    + container.escapeExpression(container.lambda((depth0 != null ? depth0.deliveryUrl : depth0), depth0))
    + "\">\n</iframe>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.reporter : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data})) != null ? stack1 : "");
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/deliveryManagement.html
// module id = 35
// module chunks = 0